<template>
  <div class="order-examine-popup">
    <el-dialog title="费用核销"
               :close-on-click-modal="false"
               :visible.sync="visible"
               width="30%" center>
      <el-form :model="dataForm" ref="dataForm" size="small" label-width="100px">
        <el-row :gutter="50">
          <el-col :span="21">
            <el-form-item :label="'付款人'" prop="writeName" :rules="[{ required: true, message: '此项不能为空', trigger: 'blur' }]">
              <el-input v-model="dataForm.writeName"  clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="21">
            <el-form-item :label="'付款日期'" prop="writeDate" :rules="[{ required: true, message: '请选择日期', trigger: 'change' }]">
              <el-date-picker
                v-model="dataForm.writeDate"
                align="right"
                type="date"
                style="width: 100%"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm">确定</el-button>
        <el-button type="primary" @click="visible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        ids: null,
        writeStatus: null,
        writeName: null,
        writeDate: null
      },
      url: null
    }
  },
  methods: {
    init (writeStatus, ids, type) {
      this.visible = true
      this.dataForm.ids = ids
      this.dataForm.writeStatus = writeStatus
      switch (type) {
        case 'costInfo':
          this.url = '/costInfo/orderRoyalty/batchWrite'
          break
        case 'sale':
          this.url = '/officeCost/saleOrderRoyalty/batchWrite'
          break
        case 'care':
          this.url = '/officeCost/careOrderRoyalty/batchWrite'
          break
        case 'saleAdmin': // 业务经理
          this.url = '/officeCost/saleAdminOrderRoyalty/batchWrite'
          break
        case 'careAdmin': // 客服经理
          this.url = '/officeCost/careAdminOrderRoyalty/batchWrite'
          break
      }
    },
    confirm () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl(this.url),
            method: 'POST',
            data: this.$http.adornData(this.dataForm)
          }).then(({ data }) => {
            if (data) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1000,
                onClose: () => {
                  this.visible = false
                  this.$emit('refreshDataList')
                }
              })
            } else {
              this.$message.error('系统错误')
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
